import { GAME_PAGES } from './gameScopeNav.jsx';
import { PORTFOLIO_PAGES } from './portfolioScopeNav.jsx';

// The sidebar icon of the page a path is on: what a dialog opened there is about (a flask on Experiments, the
// calendar on Event Definitions), so its header can wear it. Null off the game and portfolio pages.

const flatten = (pages) => pages.flatMap((p) => (p.children ? flatten(p.children) : [p]))
    .filter((p) => p.icon && typeof p.segment === 'string');

const GAME = flatten(GAME_PAGES);
const PORTFOLIO = flatten(PORTFOLIO_PAGES);

// The page whose segment is the longest match for what follows /game/<slug>/ (or /portfolio/<slug>/).
const best = (pages, rest) => pages
    .filter((p) => (p.segment === '' ? rest === '' : rest === p.segment || rest.startsWith(`${p.segment}/`)))
    .sort((a, b) => b.segment.length - a.segment.length)[0];

export const pageIconFor = (pathname) => {
    const m = String(pathname || '').match(/^\/(game|portfolio)\/[^/]+\/?(.*)$/);
    if (!m) return null;
    const rest = m[2].replace(/\/+$/, '');
    return best(m[1] === 'game' ? GAME : PORTFOLIO, rest)?.icon || null;
};
